import { render, staticRenderFns } from "./Criar-Post.vue?vue&type=template&id=33a25f3e&"
import script from "./Criar-Post.vue?vue&type=script&lang=js&"
export * from "./Criar-Post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Post.vue"
export default component.exports